<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="8">
            <a-form-item label="兑换时间">
              <t-imeTo-screen v-model="createTime" dataindex="exchangeTime"></t-imeTo-screen>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item label="优惠券使用时间">
              <t-imeTo-screen v-model="createTime" dataindex="useDate"></t-imeTo-screen>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item label="员工生日">
              <t-imeTo-screen v-model="createTime" dataindex="userBirth"></t-imeTo-screen>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="员工姓名">
              <j-input placeholder="请输入员工姓名" v-model="queryParam.userName"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="员工工号">
              <j-input placeholder="请输入员工工号" v-model="queryParam.userCode"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="兑换状态">
              <j-dict-select-tag
                placeholder="请选择兑换状态"
                v-model="queryParam.exchangeStatus"
                dictCode="birth_store_exchange_status"
              />
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="优惠券状态">
              <j-dict-select-tag
                placeholder="请选择优惠券状态"
                v-model="queryParam.couponStatus"
                dictCode="birth_store_coupon_status"
              />
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="兑换券码">
              <j-input placeholder="请输入兑换券码" v-model="queryParam.exchangeCode"></j-input>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus"> </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <!-- <a-button @click="handleAdd"
        type="primary"
        icon="plus">新增</a-button> -->
      <a-button type="primary" icon="download" @click="handleExportXls('bus_ekp_entryorboth_coupon_log')"
        >导出</a-button
      >
      <a-button type="primary" icon="gift" @click="couponPush"
      >券码补推</a-button
      >
      <!-- <a-upload name="file"
        :showUploadList="false"
        :multiple="false"
        :headers="tokenHeader"
        :action="importExcelUrl"
        @change="handleImportExcel">
        <a-button type="primary"
          icon="import">导入</a-button>
      </a-upload> -->
      <!-- <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1"
            @click="batchDel">
            <a-icon type="delete" />删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown> -->
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{ fixed: true, selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        @change="handleTableChange"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic">无此图片</span>
          <img
            v-else
            :src="getImgView(text)"
            height="25px"
            alt="图片不存在"
            style="max-width: 80px; font-size: 12px; font-style: italic"
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic">无此文件</span>
          <a-button v-else :ghost="true" type="primary" icon="download" size="small" @click="uploadFile(text)">
            下载
          </a-button>
        </template>
      </a-table>
    </div>

    <User-Modal ref="selectUserModal" @selectFinished="selectOK" />
  </a-card>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import JInput from '@/components/jeecg/JInput.vue'
import TImeToScreen from './modules/TImeToScreen.vue'
import UserModal from './modules/UserModal.vue'
import moment from 'moment'
import { postAction } from '@api/manage'
export default {
  name: 'BusEkpEntryorbothCouponLogList',
  mixins: [JeecgListMixin],
  components: {
    JInput,
    TImeToScreen,
    UserModal,
  },
  data() {
    return {
      description: 'bus_ekp_entryorboth_coupon_log管理页面',
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '用户工号',
          align: 'center',
          dataIndex: 'userCode',
        },
        {
          title: '员工姓名',
          align: 'center',
          dataIndex: 'userName',
        },
        {
          title: '兑换券码',
          align: 'center',
          dataIndex: 'exchangeCode',
        },
        {
          title: '兑换状态',
          align: 'center',
          dataIndex: 'exchangeStatus_dictText',
        },
        {
          title: '兑换时间',
          align: 'center',
          dataIndex: 'exchangeTime',
          customRender: function (text) {
            return !text ? '' : text.length > 10 ? text.substr(0, 10) : text
          },
        },
        {
          // （0: 未使用 1：已使用  2：已失效
          title: '优惠券状态',
          align: 'center',
          dataIndex: 'couponStatus',
          customRender: function (text) {
            return text == 0 ? '未使用' : text == 1 ? '已使用' : '已失效'
          },
        },
        {
          title: '优惠券使用时间',
          align: 'center',
          dataIndex: 'useDate',
          customRender: function (text) {
            return !text ? '' : text.length > 10 ? text.substr(0, 10) : text
          },
        },
        {
          title: '活动ID(优惠券ID)',
          align: 'center',
          dataIndex: 'couponId',
        },
        {
          title: '员工-券码绑定时间',
          align: 'center',
          dataIndex: 'bindTime',
          customRender: function (text) {
            return !text ? '' : text.length > 10 ? text.substr(0, 10) : text
          },
        },
        {
          title: '员工生日',
          align: 'center',
          dataIndex: 'userBirth',
          customRender: function (text) {
            return !text ? '' : text.length > 10 ? text.substr(0, 10) : text
          },
        },
        // {
        //   title: '操作',
        //   dataIndex: 'action',
        //   align: "center",
        //   scopedSlots: { customRender: 'action' }
        // }
      ],
      url: {
        list: '/customer/birthday/busEkpEntryorbothCouponLog/list',
        delete: '/customer/birthday/busEkpEntryorbothCouponLog/delete',
        deleteBatch: '/customer/birthday/busEkpEntryorbothCouponLog/deleteBatch',
        exportXlsUrl: '/customer/birthday/busEkpEntryorbothCouponLog/exportXls',
        importExcelUrl: 'customer/birthday/busEkpEntryorbothCouponLog/importExcel',
        coupon: '/customer/birthday/busEkpEntryorbothCouponLog/push',
      },
      dictOptions: {},
      createTime: {
        userBirth_begin: moment().subtract(2, 'months').format('YYYY-MM-DD'),
        userBirth_end: moment().format('YYYY-MM-DD'),
      },
    }
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  created() {},
  methods: {
    initDictConfig() {},
    couponPush(){
      this.$refs.selectUserModal.visible = true
    },
    selectOK(data) {
      let params = {
        personNum: data[0].username,
      }
      console.log(params)
      postAction(this.url.coupon, params).then((res) => {
        if (res.success) {
          this.loadData()
          this.$message.success('操作成功')
        } else {
          this.$message.warning(res.message)
        }
      })
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
